/* eslint-disable import/order */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

// Component
import App from './App';
import reportWebVitals from './reportWebVitals';

// Translation
import 'SERVICES/i18n';

// Selector
import getStore from 'STORE/Store';

// Style
import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

const { store, persistor } = getStore();
const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
